import React from 'react';
import PropTypes from 'prop-types';

import BaseDialog from 'core/components/base-dialog';
import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import { NotificationCard } from 'core/components/notification-card';
import useStyles from './non-rated-individuals.styles';

const ConfirmRemoveNonRatedIndividualModal = ({ onClose, onConfirm, open, name }) => {
  const classes = useStyles();
  return (
    <BaseDialog size="lg" onClose={onClose} open={open}>
      <div className={classes.modalContainer}>
        <Label type="greenBig">Remove {name} as a non-rated individual?</Label>
        <Label type="modalBody">
          They won’t be listed on the policy, which may expose both them and Branch to risk in case of a being involved
          in a claim.
        </Label>
        <NotificationCard className={classes.warning} type="light">
          If you want to add this person as a driver on the policy, please add them as a driver first, instead.
        </NotificationCard>
        <div className={classes.buttonContainer}>
          <Button className={classes.buttons} variant="contained" color="secondary" onClick={onClose}>
            No, keep them as a non-rated individual
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm} className={classes.buttons}>
            Yes, remove them as a non-rated individual
          </Button>
        </div>
      </div>
    </BaseDialog>
  );
};

ConfirmRemoveNonRatedIndividualModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired
};

export default ConfirmRemoveNonRatedIndividualModal;
